import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const errMsg = (e, fallback = "Une erreur est survenue. Réessaie.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (!e?.response) return "Connexion au serveur impossible. Vérifie ta connexion internet.";
  return fallback;
};

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const hasFeature = (user, f) => !!user?.features?.includes(f);
